// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___e4fce0133a5481aa702","cls2":"Comments-cls2__fd6546a830dc0cb02ef6 Comments-cls1___e4fce0133a5481aa702"};